import script from "./BORA.vue?vue&type=script&setup=true&lang=js"
export * from "./BORA.vue?vue&type=script&setup=true&lang=js"

import "./BORA.vue?vue&type=style&index=0&id=2543356a&lang=css"

const __exports__ = script;

export default __exports__